import Axios from "axios";

let aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

// Cliente autenticado — para gerenciamento pelo técnico
const aiHttp = Axios.create({ baseURL: aiBaseURL });
const local = JSON.parse(localStorage.getItem("user-token") || "null");
if (local && local.token) {
  aiHttp.defaults.headers.common["Authorization"] = "bearer " + local.token;
}
aiHttp.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// Cliente público — sem autenticação (formulário público)
const publicHttp = Axios.create({ baseURL: aiBaseURL });

class SurveyService {
  // ── Admin — Perguntas base ───────────────────────────────────────────────

  ListBaseQuestions(stageCode = "participatory_diagnosis") {
    return aiHttp({ url: "/survey/base-questions", method: "GET", params: { stage_code: stageCode } });
  }

  UpdateBaseQuestion(code, data) {
    return aiHttp({ url: "/survey/base-questions/" + code, data, method: "PUT" });
  }

  // ── Formulário ───────────────────────────────────────────────────────────

  GetForm(contaId, stageCode = "participatory_diagnosis") {
    return aiHttp({ url: "/survey/forms/" + contaId, method: "GET", params: { stage_code: stageCode } });
  }

  UpdateForm(formId, data) {
    return aiHttp({ url: "/survey/forms/" + formId, data, method: "PUT" });
  }

  // ── Perguntas customizadas ───────────────────────────────────────────────

  CreateQuestion(formId, data) {
    return aiHttp({ url: "/survey/forms/" + formId + "/questions", data, method: "POST" });
  }

  UpdateQuestion(formId, questionId, data) {
    return aiHttp({
      url: "/survey/forms/" + formId + "/questions/" + questionId,
      data,
      method: "PUT"
    });
  }

  DeleteQuestion(formId, questionId, archive = true) {
    return aiHttp({
      url: "/survey/forms/" + formId + "/questions/" + questionId,
      method: "DELETE",
      params: { archive }
    });
  }

  // ── Edições ──────────────────────────────────────────────────────────────

  ListEditions(contaId, stageCode = "participatory_diagnosis") {
    return aiHttp({ url: "/survey/forms/" + contaId + "/editions", method: "GET", params: { stage_code: stageCode } });
  }

  CreateEdition(contaId, data, stageCode = "participatory_diagnosis") {
    return aiHttp({
      url: "/survey/forms/" + contaId + "/editions",
      data,
      method: "POST",
      params: { stage_code: stageCode }
    });
  }

  // ── Respostas e relatório ────────────────────────────────────────────────

  ListResponses(formId, skip = 0, limit = 50, reviewStatus = null, search = null, chapterId = null) {
    const params = { skip, limit };
    if (reviewStatus) params.review_status = reviewStatus;
    if (search) params.search = search;
    if (chapterId) params.chapter_id = chapterId;
    return aiHttp({
      url: "/survey/forms/" + formId + "/responses",
      method: "GET",
      params
    });
  }

  UpdateResponseDescription(responseId, description) {
    return aiHttp({
      url: "/survey/responses/" + responseId + "/description",
      data: { description },
      method: "PUT"
    });
  }

  ReviewResponse(responseId, outcome, notes) {
    return aiHttp({
      url: "/survey/responses/" + responseId + "/review",
      data: { outcome, notes },
      method: "PUT"
    });
  }

  GetReport(formId) {
    return aiHttp({ url: "/survey/forms/" + formId + "/report", method: "GET" });
  }

  ExportResponses(formId) {
    return aiHttp({ url: "/survey/forms/" + formId + "/export", method: "GET", responseType: "blob" });
  }

  GetResponse(responseId) {
    return aiHttp({ url: "/survey/responses/" + responseId, method: "GET" });
  }

  DeleteResponse(responseId) {
    return aiHttp({ url: "/survey/responses/" + responseId, method: "DELETE" });
  }

  ExportRespostasByConta(contaId, stageCode = "participatory_diagnosis") {
    return aiHttp({
      url: "/survey/export/" + contaId,
      method: "GET",
      responseType: "blob",
      params: { stage_code: stageCode }
    });
  }

  // ── Público (sem auth) ───────────────────────────────────────────────────

  GetPublicForm(token) {
    return publicHttp({ url: "/public/survey/" + token, method: "GET" });
  }

  SubmitResponse(token, answers) {
    return publicHttp({
      url: "/public/survey/" + token + "/submit",
      data: { answers },
      method: "POST"
    });
  }
}

export default new SurveyService();
